import { CircleAlert, RefreshCw } from "lucide-react";
import { useT } from "../i18n";
import { useErrorMessage } from "../lib/use-error-message";
import { ApiError } from "../lib/api";
import { Button } from "./Button";
import { EmptyState } from "./EmptyState";

export interface ErrorStateProps {
  error: unknown;
  /** Shows a Try again button. */
  onRetry?: () => void;
  retrying?: boolean;
  className?: string;
}

export function ErrorState({ error, onRetry, retrying, className }: ErrorStateProps) {
  const t = useT();
  const message = useErrorMessage();
  const requestId = error instanceof ApiError ? error.requestId : undefined;
  return (
    <EmptyState
      tone="danger"
      role="alert"
      className={className}
      icon={<CircleAlert aria-hidden />}
      title={t("errors.title")}
      description={message(error)}
      action={
        onRetry || requestId ? (
          <div className="flex flex-col items-center gap-3">
            {onRetry ? (
              <Button variant="secondary" icon={<RefreshCw aria-hidden />} loading={retrying} onClick={onRetry}>
                {t("common.retry")}
              </Button>
            ) : null}
            {requestId ? <p className="text-xs text-fg-subtle">{t("errors.reference", { id: requestId })}</p> : null}
          </div>
        ) : null
      }
    />
  );
}
